import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/edit.svg'
import _imports_1 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_5 = { class: "fw-semibold text-dark" }
const _hoisted_6 = { class: "text-muted small" }
const _hoisted_7 = {
  key: 1,
  class: "code-pill"
}
const _hoisted_8 = {
  key: 2,
  class: "description-cell"
}
const _hoisted_9 = {
  key: 3,
  class: "d-flex justify-content-center gap-2 table-actions"
}
const _hoisted_10 = ["title", "onClick"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.categories,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.paginationConfig,
        scroll: { x: 860 },
        class: "text-nowrap align-middle expense-category-table"
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("expense_category_page.no_expense_categories_found")), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'name')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(record.name || _ctx.t("expense_category_page.not_available_short")), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t("expense_category_page.category_label")), 1)
              ]))
            : (column && column.key === 'code')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.code || _ctx.t("expense_category_page.not_available_short")), 1))
              : (column && column.key === 'description')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.description || _ctx.t("expense_category_page.no_description")), 1))
                : (column && column.key === 'actions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn p-0 border-0 action-icon-btn",
                        title: _ctx.t('expense_category_page.edit'),
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#expenseCategoryModal",
                        onClick: ($event: any) => (_ctx.$emit('edit-category', record))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: _ctx.t('expense_category_page.edit'),
                          style: {"width":"14px"}
                        }, null, 8, _hoisted_11)
                      ], 8, _hoisted_10),
                      _createElementVNode("button", {
                        class: "btn p-0 border-0 action-icon-btn",
                        title: _ctx.t('expense_category_page.delete'),
                        onClick: ($event: any) => (_ctx.$emit('delete-category', record))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: _ctx.t('expense_category_page.delete'),
                          style: {"width":"14px"}
                        }, null, 8, _hoisted_13)
                      ], 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination"])
    ])
  ]))
}